import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBooking } from '../actions/bookingActions';
import LeadForm from '../components/LeadForm';

const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(n);

export default function BookingDetail() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const booking = useSelector(s => s.bookings.current);
  useEffect(() => { dispatch(fetchBooking(id)); }, [dispatch, id]);

  if (!booking || booking._id !== id) return <section className="section"><p>Loading…</p></section>;

  const photo = (booking.photos && booking.photos[0]) || `https://placehold.co/1200x675/0a1a2e/ffffff?text=${encodeURIComponent(booking.make + ' ' + booking.model)}`;

  return (
    <section className="section">
      <p className="crumbs"><Link to="/inventory">← Back to inventory</Link></p>
      <div className="detail-grid">
        <div>
          <div className="detail-photo" style={{ backgroundImage: `url(${photo})` }} />
          <h1>{booking.year} {booking.make} {booking.model}</h1>
          <p className="detail-price">{fmt(booking.price)}</p>
          <p className="muted">{(booking.mileage || 0).toLocaleString()} miles · {booking.bodyStyle} · {booking.fuelType} · {booking.transmission} · {booking.drivetrain}</p>
          <p>{booking.description}</p>
          {booking.features && booking.features.length > 0 && (
            <>
              <h3>Features</h3>
              <ul className="features">
                {booking.features.map(f => <li key={f}>{f}</li>)}
              </ul>
            </>
          )}
        </div>
        <aside>
          <LeadForm booking={booking} />
        </aside>
      </div>
    </section>
  );
}
